// extracted by mini-css-extract-plugin
export default {"itemPrimaryContainer":"RelatedToView_itemPrimaryContainer__ETFpT"};